import { Routes } from '@angular/router';
import { authGuard } from '../shared/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    title: 'Accedi',
    loadComponent: () => import('./auth/login.page.component').then((m) => m.LoginPageComponent),
  },
  {
    path: 'auth/check',
    title: 'Accesso in corso',
    loadComponent: () =>
      import('./auth/auth-check.page.component').then((m) => m.AuthCheckPageComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/app-shell.component').then((m) => m.AppShellComponent),
    children: [
      {
        path: 'search',
        loadChildren: () =>
          import('./features/agrochemicals/agrochemicals.routes').then(
            (m) => m.agrochemicalsCoreRoutes,
          ),
      },
      { path: '', pathMatch: 'full', redirectTo: 'search' },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
